import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/react';
import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
} from 'react';
import { INotfisResponse } from '../../../../interfaces/response/Notfis/INotfisResponse';
import { ECargoType } from '../../hooks/useCheckOrders';
import OrderCbaTag from './components/OrderTag/OrderCbaTag';
import OrderFastTag from './components/OrderTag/OrderFastTag';
import { usePrintOrderTagModal } from './hooks/usePrintOrderTagModal';

export interface IPrintOrderTagModalHandle {
  openModalToPrint: (nfKey: string, auto: boolean) => void;
  openModal: (printedTag: INotfisResponse) => void;
  closeModal: () => void;
}

interface IPrintOrderTagModalProps {
  etiqueta: string;
  resetNfeKeyField: () => void;
  tipoCarga: ECargoType;
}

const PrintOrderTagModal: ForwardRefRenderFunction<
  IPrintOrderTagModalHandle,
  IPrintOrderTagModalProps
> = ({ etiqueta, resetNfeKeyField, tipoCarga }, ref): JSX.Element => {
  const {
    isOpen,
    onOpenChange,
    theme,
    handleOpenModal,
    handleOpenModalToShowTag,
    handleCloseModal,
    loading,
    handlePrint,
    tagData,
    tagRef,
  } = usePrintOrderTagModal({
    resetNfeKeyField,
    tipoCarga,
  });

  useImperativeHandle(ref, () => ({
    openModalToPrint: (nfKey: string, auto: boolean) => {
      handleOpenModal(nfKey, auto);
    },
    openModal: (printedTag: any) => {
      handleOpenModalToShowTag(printedTag);
    },
    closeModal: () => {
      handleCloseModal();
    },
  }));

  return (
    <Modal
      isOpen={isOpen}
      // isOpen
      onOpenChange={onOpenChange}
      className={`${theme}`}
      onClose={handleCloseModal}
    >
      <ModalContent>
        {/* Header */}
        <ModalHeader className="text-default-600">
          Imprimir etiqueta
        </ModalHeader>

        {/* Body */}
        <ModalBody>
          {/* Loading Spinner */}
          {/* {tagData === null && <Spinner />} */}

          {/* Information text */}
          {tagData && (
            <p className="text-sm text-default-700">
              Imprimir etiqueta do pedido{' '}
              <span className="font-bold">número da nota do pedido</span>?
            </p>
          )}

          {/* Order Table */}
          <div className="flex justify-center">
            <div className="rounded-xl border border-foreground-300">
              {/* <OrderTag
                tagData={teste}
                etiqueta={teste.notfis.volumes[0].etiqueta}
              /> */}
              {tagData && (
                <div
                  ref={tagRef}
                  className="h-[7.5cm] w-[10cm] overflow-hidden rounded-xl"
                >
                  {etiqueta.length === 29 ? (
                    <OrderFastTag tagData={tagData} etiqueta={etiqueta} />
                  ) : (
                    <OrderCbaTag tagData={tagData} etiqueta={etiqueta} />
                    // <OrderTag tagData={tagData} etiqueta={etiqueta} />
                  )}
                </div>
              )}
            </div>
          </div>
        </ModalBody>

        {/* Footer */}
        <ModalFooter>
          <Button color="danger" onPress={handleCloseModal}>
            Cancelar
          </Button>

          <Button type="button" onPress={handlePrint} isLoading={loading}>
            Imprimir
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default forwardRef(PrintOrderTagModal);
